module.exports = __webpack_public_path__ + "assets/icon-arrow-hide-b3ae8ae3fd2fd7f9f244fc73f63b05a6.svg";